﻿
// Override tabstrip call
kendo.ui.TabStrip.fn.ajaxRequest = function (element, content, complete, url) {
    element = this.tabGroup.find(element);

    var that = this,
        xhr = $.ajaxSettings.xhr,
        link = element.find("." + "k-link"),
        data = {},
        halfWidth = element.width() / 2,
        fakeProgress = false,
        statusIcon = element.find(".k-loading").removeClass("k-complete");

    if (!statusIcon[0]) {
        statusIcon = $("<span class='k-loading'/>").prependTo(element);
    }

    var endState = halfWidth * 2 - statusIcon.width();

    var oldProgressAnimation = function () {
        statusIcon.animate({ marginLeft: (parseInt(statusIcon.css("marginLeft"), 10) || 0) < halfWidth ? endState : 0 }, 500, oldProgressAnimation);
    };

    if (kendo.support.browser.msie && kendo.support.browser.version < 10) {
        setTimeout(oldProgressAnimation, 40);
    }

    url = url || link.data("contentUrl") || that._contentUrls[element.index()] || link.attr("href");
    that.inRequest = true;

    var ajaxOptions = {
        disableLoadIndicator: true, //Dont increase the numberrequests counter in main.js
        type: "GET",
        cache: false,
        url: url,
        dataType: "html",
        data: data,
        xhr: function () {
            var current = this,
                request = xhr(),
                event = current.progressUpload ? "progressUpload" : current.progress ? "progress" : false;

            if (request) {
                $.each([request, request.upload], function () {
                    if (this.addEventListener) {
                        this.addEventListener("progress", function (evt) {
                            if (event) {
                                current[event](evt);
                            }
                        }, false);
                    }
                });
            }

            current.noProgress = !(window.XMLHttpRequest && ('upload' in new XMLHttpRequest()));
            return request;
        },

        progress: function (evt) {
            if (evt.lengthComputable) {
                var percent = parseInt((evt.loaded / evt.total * 100), 10) + "%";
                statusIcon
                    .stop(true)
                    .addClass("k-progress")
                    .css({
                        "width": percent,
                        "marginLeft": 0
                    });
            }
        },

        error: function (xhr, status) {
            if (that.trigger("error", { xhr: xhr, status: status })) {
                this.complete();
            }
        },

        stopProgress: function () {
            clearInterval(fakeProgress);
            statusIcon
                .stop(true)
                .addClass("k-progress")[0].style.cssText = "";
        },

        complete: function (xhr) {
            that.inRequest = false;
            if (this.noProgress) {
                setTimeout(this.stopProgress, 500);
            } else {
                this.stopProgress();
            }

            if (xhr.statusText == "abort") {
                statusIcon.remove();
            }
        },

        success: function (data) {
            statusIcon.addClass("k-complete");
            try {
                var current = this,
                    loaded = 10;

                if (current.noProgress) {
                    statusIcon.width(loaded + "%");
                    fakeProgress = setInterval(function () {
                        current.progress({ lengthComputable: true, loaded: Math.min(loaded, 100), total: 100 });
                        loaded += 10;
                    }, 40);
                }

                kendo.destroy(content);
                content.html(data);
            } catch (e) {
                var console = window.console;

                if (console && console.error) {
                    console.error(e.name + ": " + e.message + " in " + url);
                }
                this.error(this.xhr, "error");
            }

            if (complete) {
                complete.call(that, content);
            }

            that.trigger("contentLoad", { item: element[0], contentElement: content[0] });
        }
    };

    if (typeof url === "object") {
        ajaxOptions = $.extend(true, {}, ajaxOptions, url);

        if (kendo.isFunction(ajaxOptions.url)) {
            ajaxOptions.url = ajaxOptions.url();
        }
    }

    that.xhr = $.ajax(ajaxOptions);
},

kendo.ui.Window.fn._ajaxRequest = function (options) {
    this._loadingIconTimeout = setTimeout(this._showLoading.bind(this), 100);
    
    $.ajax($.extend({
        type: "GET",
        dataType: "html",
        disableLoadIndicator: true, //Dont increase the numberrequests counter in main.js
        cache: false,
        error: this._ajaxError.bind(this),
        complete: this._ajaxComplete.bind(this),
        success: this._ajaxSuccess(options.template).bind(this)
    }, options));
}
